/**************************************************************************************************/
/** @import Helpers/Components                                                                   **/
/**************************************************************************************************/
import { BaseInput } from '@/Helpers/Components/DataForm/BaseInput'

/**************************************************************************************************/
/** @export Class @name InputButton                                                              **/
/**************************************************************************************************/
export class InputButton extends BaseInput
{
	/*************************************************/
	/** @Properties                                 **/
	/*************************************************/
	private data: { value: string }

	/*************************************************/
	/** @Constructor                                **/
	/*************************************************/
	constructor(key: string, label: string)
	{
		super()
		this.Key   = key
		this.Label = label
		this.Type  = 'InputButton'
		this.data  = { value: '' }
		this.setParamsState(this.resolveInputState)
		this.setParamsType('text')
	}

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	public get Data() : { value: string }
	{
		return this.data
	}

	public set Data(value)
	{
		this.data = value
	}

	public resolveInputState(self: any) : boolean | null
	{
		if (self.data.value === '') return null
		return true
	}

	public setParamsIcon(icon: (string | [string, string])) : this
	{
		this.Params.button = { content: 'icon', icon }
		return this
	}

	public setParamsRequires(field: string, friendly: string, values: any) : this
	{
		this.Params.requires = { field, friendly, values }
		return this
	}

	public setParamsType(type: string) : any
	{
		this.Params.type = type
		return this
	}
}